module.exports = __webpack_public_path__ + "img/cat-clothing.4122bc4d.png";